var React = require('react');

function Notify (props) {
    return React.createElement("svg",props,[React.createElement("rect",{"id":"Rectangle_37724","data-name":"Rectangle 37724","width":"22","height":"22","fill":"none","key":0}),React.createElement("path",{"id":"bell-r","d":"M12,2.25A7.75,7.75,0,0,0,4.25,10v3.323l-1,2V18.25h5a3.75,3.75,0,0,0,7.5,0h5V15.323l-1-2V10A7.75,7.75,0,0,0,12,2.25Zm2.25,16H9.75a2.25,2.25,0,0,0,4.5,0ZM5.75,10a6.25,6.25,0,0,1,12.5,0v3.677l1,2V16.75H4.75V15.677l1-2Z","transform":"translate(-1 -1.125)","fill":"currentColor","fillRule":"evenodd","key":1})]);
}

Notify.defaultProps = {"id":"notify1","width":"22","height":"22","viewBox":"0 0 22 22"};

module.exports = Notify;

Notify.default = Notify;
